import { Component } from "@angular/core";

@Component({
	selector: "caass-IDAdmin",
	templateUrl: "./IDAdmin.component.html",
})
export class IDAdminComponent {}
